import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface RecommendationsResponse {
  assessmentId: string;
  aiReadinessScore: number;
  recommendations: AIAgentRecommendation[];
}

export interface AIAgentRecommendation {
  name: string;
  description: string;
  roiEstimate: string;
  timeToValue: string;
  complexity: 'Low' | 'Medium' | 'High';
  budgetRange: string;
  keyBenefits: string[];
  implementationSteps: string[];
  riskFactors: string[];
}

export const recommendationService = {
  getRecommendations: async (assessmentId: string): Promise<RecommendationsResponse> => {
    const response = await apiClient.get(`/recommendations/${assessmentId}`);
    return response.data.data;
  },

  generateCustomRecommendations: async (
    assessmentData: any, 
    preferences?: any
  ): Promise<RecommendationsResponse> => {
    const response = await apiClient.post('/recommendations/generate', {
      assessmentData,
      preferences
    });
    return response.data.data;
  }
};

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Recommendation API Error:', error);
    
    if (error.response) {
      const message = error.response.data?.error?.message || 'Errore nel recupero delle raccomandazioni';
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Errore di connessione. Verifica la tua connessione internet.');
    } else {
      throw new Error('Errore imprevisto. Riprova tra qualche minuto.');
    }
  }
);